import { render, staticRenderFns } from "./NuevoEvento.vue?vue&type=template&id=0b134f18"
import script from "./NuevoEvento.vue?vue&type=script&lang=js"
export * from "./NuevoEvento.vue?vue&type=script&lang=js"
import style0 from "./NuevoEvento.vue?vue&type=style&index=0&id=0b134f18&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b134f18')) {
      api.createRecord('0b134f18', component.options)
    } else {
      api.reload('0b134f18', component.options)
    }
    module.hot.accept("./NuevoEvento.vue?vue&type=template&id=0b134f18", function () {
      api.rerender('0b134f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Views/EstadosMobile/components/NuevoEvento.vue"
export default component.exports